<template>
  <!-- <DrawerItem class="items-center justify-center text-center" :icon="darkModeEnabled ? tabOutlineSun : tabOutlineMoon" :name="darkModeEnabled ? 'Light' : 'Dark'" @click="toggleDarkMode(false)" /> -->
  <q-btn flat class="q-ma-lg text-grey bg-transparent" size="md" @click="toggleDarkMode(false)">
    <span class="items-center justify-center text-center">
      <q-icon :name="darkModeEnabled ? tabOutlineSun : tabOutlineMoon"></q-icon>
      <span class="q-ml-sm col" v-if="!mini">{{ darkModeEnabled ? 'Light' : 'Dark' }} </span>
    </span>
  </q-btn>
</template>

<script setup>
import { ref } from 'vue';
import { tabOutlineMoon, tabOutlineSun } from 'quasar-extras-svg-icons/tabler-icons-v3';

import {
  enable as enableDarkMode,
  disable as disableDarkMode,
  isEnabled as isDarkReaderEnabled,
} from 'darkreader';

defineProps({
  mini: {
    required: false,
    default: false,
  },
});
const darkModeEnabled = ref(localStorage.getItem('darkReaderEnabled') === 'true');
const toggleDarkMode = (force) => {
  if (!isDarkReaderEnabled()) {
    enableDarkMode({
      brightness: 100,
      contrast: 125,
      sepia: 0,
      grayscale: 0,
      useFont: true,
      applyUsingCSS: true,
    });
    darkModeEnabled.value = true;
  } else if (!force) {
    disableDarkMode();
    darkModeEnabled.value = false;
  }
  localStorage.setItem('darkReaderEnabled', darkModeEnabled.value.toString());
};

// Set dark mode on page load
if (darkModeEnabled.value) {
  toggleDarkMode(true);
}
</script>
